// Copyright (c) Docugami, Inc. All rights reserved.

import { DgMultineEllipsis } from "components/common/DgCommonStyledComponents";
import { Drive } from "@microsoft/microsoft-graph-types"
import { Icon } from "@fluentui/react";
import styled from "styled-components";
import { FontSizes } from '@fluentui/react/lib/Styling';
import { backgroundGray } from "components/shell/presentation/AppStyles";
import { FileIconType, getFileTypeIconProps } from '@fluentui/react-file-type-icons';

const RootContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
`

const PickerItemText = styled(DgMultineEllipsis)`
    font-size: ${FontSizes.medium};
`

const Title = styled.span`
    font-size: ${FontSizes.large};
    margin-top: 15px;
`

const PickerContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    margin-left: 10px;
`

const PickerItemContainer = styled.div`
    width: 150px;
    height: max-content;
    padding: 10px;
    box-sizing: border-box;
    display: flex;
    flex: 0 0 content;
    flex-direction: column;
    text-align: center;
    margin: 5px 5px 0 0;
    :hover {
        cursor: pointer;
        background: ${backgroundGray};
        text-decoration: underline;
        :active {
            transform: scale(.97);
            transform-origin: center;
            transition: all .08s ease-out;
        }
    }
`

const PickerItemIconContainer = styled.div`
    display: flex;
    flex: 1;
    align-items: center;
    justify-content: center;
`

const TextContainer = styled.div`
    height: 40px;
`

interface GraphDrivePickerProps {
    title: string;
    drives: Partial<Drive>[];
    onSelected: (item: Partial<Drive>) => void;
}

export const GraphDrivePicker = (props: GraphDrivePickerProps): JSX.Element => {
    return (
        <RootContainer>
            <Title>{props.title}</Title>
            <PickerContainer>
                {
                    props.drives.map(drive => {
                        return (
                            <PickerItemContainer key={drive.id!} onClick={() => props.onSelected(drive)}>
                                <PickerItemIconContainer>
                                    <Icon {...getFileTypeIconProps({ type: FileIconType.folder, size: 96 })} />
                                </PickerItemIconContainer>
                                <TextContainer>
                                    <PickerItemText numLines={2}>{drive.name!}</PickerItemText>
                                </TextContainer>
                            </PickerItemContainer>
                        );
                    })
                }
            </PickerContainer>
        </RootContainer>
    )
}
